import { HandleChangeTextArgs } from "./props";
import { inputPatterns } from "./constant";

/**
 * Handles text change events with pattern validation
 */
export function handleChangeText({ text, type, inputPattern, onChangeText }: HandleChangeTextArgs): void {
  const textChangePattern: RegExp = inputPattern ?? inputPatterns[type ?? "text"] ?? /.*/;
  if (!textChangePattern.test(text)) return;
  onChangeText?.(text);
}
